import { z } from 'zod';
import { rolSchema } from '../roles.js';

export const girisSchema = z.object({
  eposta: z.string().email('Geçerli bir e-posta girin'),
  sifre: z.string().min(8, 'Şifre en az 8 karakter olmalı'),
  /** Kullanici birden fazla tesise bagli ise hangi tesise girildigi */
  tenantId: z.string().optional(),
});
export type Giris = z.infer<typeof girisSchema>;

export const jwtPayloadSchema = z.object({
  sub: z.string(), // user id
  tid: z.string(), // tenant id  -> HER sorgu bununla filtrelenir
  roller: z.array(rolSchema),
  /** token tipi: erisim veya yenileme */
  typ: z.enum(['access', 'refresh']),
  iat: z.number(),
  exp: z.number(),
  jti: z.string(),
});
export type JwtPayload = z.infer<typeof jwtPayloadSchema>;

export const ACCESS_TOKEN_OMRU_SN = 15 * 60; // 15 dk
export const REFRESH_TOKEN_OMRU_SN = 30 * 24 * 60 * 60; // 30 gun
